import React, { EventHandler, SyntheticEvent } from 'react'

interface Props extends React.ComponentPropsWithRef<'a'> {
  onClick: EventHandler<SyntheticEvent>
}

export const KebabToggle = ({ onClick, ref }: Props) => (
  <a
    className={'post-context-menu-control'}
    href=""
    ref={ref}
    onClick={e => {
      e.preventDefault()
      e.stopPropagation()
      onClick(e)
    }}
    data-testid={'post-context-menu'}
  >
    &#8942;
  </a>
)
